<template>
  <v-container fluid>
    <v-row dense>
      <v-col class="text-h3 gray--text text--lighten-1">
        <PatientsCounter
          queueTitle="Atendimentos"
          queueType="doctor"
          :employeeId="employeeId"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <authorization permissionKey="doctor_queue" can="read">
          <Attendances queueType="doctor" :employeeId="employeeId">
            <template v-slot:attendance="{ attendance, refreshQueue }">
              <MedicalRequestQueue
                :attendance="attendance"
                queueType="doctor"
                :refreshQueueProps="refreshQueue"
                :employeeId="employeeId"
              />
            </template>
          </Attendances>
        </authorization>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Attendances from "@/components/queues/attendances.vue";
  import MedicalRequestQueue from "@/components/medical_request/queue.vue";
  import PatientsCounter from "@/components/queues/attendance/patients_counter.vue";

  export default {
    name: "doctor",
    components: {
      Attendances,
      MedicalRequestQueue,
      PatientsCounter,
    },
    computed: {
      employeeId() {
        return this.$store.state.authentication.user.employee.id;
      },
    },
  };
</script>

<style lang="sass" scoped></style>
